import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useToggle } from 'hooks';
import StyledSideBadge from 'ui/StyledSideBadge';

interface IProps {
  title?: string;
  isOpen?: boolean;
  children?: React.ReactNode;
  selectedCount?: number;
}

const FacetSectionWrapper = ({
  title = '',
  isOpen = false,
  children = null,
  selectedCount = 0,
}: IProps) => {
  const theme = useTheme();
  const { val: isSectionOpen, toggle: toggleIsSectionOpen } = useToggle(isOpen);
  return (
    <Accordion
      TransitionProps={{ unmountOnExit: true }}
      disableGutters
      expanded={isSectionOpen}
      onChange={toggleIsSectionOpen}
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        '&:not(:last-child)': {
          borderBottom: 0,
        },
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        sx={{
          backgroundColor: theme.palette.grey[200],
          color: theme.palette.primary.dark,
        }}
        expandIcon={
          <ExpandMoreIcon sx={{ color: theme.palette.primary.dark }} />
        }
      >
        <Typography>{title}</Typography>
        <StyledSideBadge badgeContent={selectedCount} color='primary' />
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default FacetSectionWrapper;
